import React from 'react';
import PropTypes from 'prop-types';

/**
 * Wrapper element for template content
 */
const ContentWrapper = props => (
    <div className="content-wrapper" style={props.style}>
        {props.unwrap ?
            (<div className="unwrap">{props.children}</div>)
            :
            (props.children)
        }
    </div>
)

ContentWrapper.propTypes = {
    /** add element with 'unwrap' class to expand content area */
    unwrap: PropTypes.bool,
    style: PropTypes.object
}
ContentWrapper.defaultProps = {
    unwrap: false,
    style: {}
}

export default ContentWrapper;
